export const swalConstants = {
  SHOW: 'SHOW_ALERT',
  HIDE: 'HIDE_ALERT'
};
